export const calculateTotalCount = elements => elements.reduce((total, current) => current.count + total, 0);
export const calculateConversationRate = (conversions, evaluations) => Math.round(conversions / evaluations * 100);
export const getCloudConversionsTableData = cloudConversionsAPIResponse => cloudConversionsAPIResponse.addons.map(response => {
  var _response$series$find, _response$series$find2, _response$series$find3, _response$series$find4;

  const evaluationsElements = (_response$series$find = (_response$series$find2 = response.series.find(item => item.name === 'Evaluations')) === null || _response$series$find2 === void 0 ? void 0 : _response$series$find2.elements) !== null && _response$series$find !== void 0 ? _response$series$find : [];
  const conversionsElements = (_response$series$find3 = (_response$series$find4 = response.series.find(item => item.name === 'Conversions')) === null || _response$series$find4 === void 0 ? void 0 : _response$series$find4.elements) !== null && _response$series$find3 !== void 0 ? _response$series$find3 : [];
  const evaluations = calculateTotalCount(evaluationsElements);
  const conversions = calculateTotalCount(conversionsElements);
  return {
    appKey: response.addonKey,
    appName: response.name,
    conversions,
    evaluations,
    conversationRate: calculateConversationRate(conversions, evaluations)
  };
});